export default function dataFormatter(data) {
  const arr = [];
  for (let key in data) {
    arr.push(data[key]);
  }
  return arr;
}



// WEBPACK FOOTER //
// ./src/utils/dataFormatter.js